<template>
    <v-app class="bgImage">
        <m-errorbox ref="errorBox"></m-errorbox>
        <navbar />
        <v-content class="secondary--text text--darken-2">
            <v-container fluid class="fill-height">
                <v-card width="100%" class="fill-height">
                    <v-card-actions>

                        <v-col cols="12" sm="3" >
                            <v-text-field type="number" style="width:100px;" label="Address" v-model="memAddress">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" >
                            <v-text-field type="number" style="width:100px;" label="Length" v-model="memLength">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" >
                            <v-text-field type="number" style="width:100px;" label="Multiplier" v-model="memMultiplier">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" >
                            <v-btn @click="onLoadMemory">Load Memory</v-btn>
                        </v-col>

                    </v-card-actions>
                    <v-card-text>
                        <v-simple-table style="font-family:monospace;" class="my-0 py-0" dense>
                            <tbody>
                                <tr v-for="(result, index) in results" :key="index" >
                                    <!--th v-for="c in 17" :key="c" style="color:blue; font-weight:bold; background:#EEEEEE;">{{ (c < 2) ? "" : c-2 }}</th-->
                                    <td v-for="(cell, cellindex) in result" :key="cellindex"
                                    :style="{color:(cellindex == 0 || result[0] === '') ? 'blue' : '', background:(result[0] === '') ? '#EEEEEE' : '', fontWeight:(cellindex == 0 || result[0] === '') ? 'bold' : ''}"
                                    >{{ cell }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import usbRequest from '../mixins/usb-request';

function buf2Hex(buffer) { // buffer is an ArrayBuffer
  return Array.prototype.map.call(new Uint8Array(buffer), x => ('00' + x.toString(16)).slice(-2)).join('').toUpperCase();
}

function hex2buf(strHex){
    // handle empty string
    if (! strHex) return []

    strHex = cleanHexString(strHex);

    return strHex.match(/[\da-f]{2}/gi).map(function (h) {
        return parseInt(h, 16)
    });
}

export default {
    mixins:[usbRequest],
    data() {
        return {
            results:[],
            displayAddress:256,
            memAddress:256,
            memLength:4096,
            memMultiplier:1,
        };
    },
    mounted(){
        //this.usbRequest('device', this.$route.params.id).then(r=>console.log(r));
    },
    methods:{
        showError(message){
            this.$refs.errorBox.showError(message);
        },
        log(strVal){

            //this.results.push(strVal);
        },
        // returns command response on FAIL, and false on PASS
        async onLoadMemory(evt){
            let address = this.memAddress * this.memMultiplier;
            let length = this.memLength * this.memMultiplier;
            // normalise memory values to block size
            address = Math.floor(address/256)*256;
            length = Math.ceil(length/256)*256;

            if (length < 256) length = 256;
            this.displayAddress = address;
            this.results = [];
            for(let i = address; i < address + length; i += 256){
                this.results.push(["",0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15])
                let addr = i%(4096*4096);
                let vals = await this.usbReadFlash(addr,256);
                for (let j=0; j<256; j+=16){
                    this.results.push([addr+j, ...vals.slice(j, j+16)]);
                }
            }
        }
    },
    watch:{
    },
    updated: function () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been re-rendered
            //window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
        });
    },
};
</script>

<style lang="stylus">
.fail
    color red
    font-weight bold
.pass
    color green
.wait
    color orange

</style>
